document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    copyAndPrependCouponSlide();
  }, 5000); // 5000 millisecondi = 5 secondi
});

// Ascolta eventi di add to cart di Shopify
document.addEventListener('cart:updated', () => {
  console.log('Cart updated event detected');
  setTimeout(() => {
    copyAndPrependCouponSlide();
  }, 500);
});

document.addEventListener('product:added', () => {
  console.log('Product added event detected');
  setTimeout(() => {
    copyAndPrependCouponSlide();
  }, 500);
});

function copyAndPrependCouponSlide() {
  if(document.querySelector('.footer-cart-drawer-mobile .x-splide-slide')){
    return;
  }
  const sourceContainer = document.querySelector('#x-slide-announcement-bar-track');
  if (!sourceContainer) {
    console.warn('Source container #x-slide-announcement-bar-track not found.');
    return;
  }

  const slides = sourceContainer.querySelectorAll('.x-splide-slide');
  let sourceSlideToCopy = null;

  for (const slide of slides) {
    if (slide.querySelector('[x-data="xCouponCode"]')) {
      sourceSlideToCopy = slide;
      break;
    }
  }

  if (!sourceSlideToCopy) {
    console.warn('No .x-splide-slide containing [x-data="xCouponCode"] found in #x-slide-announcement-bar-track.');
    return;
  }

  const destinationElement = document.querySelector('.footer-cart-drawer-mobile');
  if (!destinationElement) {
    console.warn('Destination element .footer-cart-drawer-mobile not found.');
    return;
  }

  const clonedSlide = sourceSlideToCopy.cloneNode(true);
  destinationElement.prepend(clonedSlide);
  console.log('Successfully copied and prepended the coupon slide.');
}